import * as types from './mutations-types'

export default {
  [types.addFlash] (state, flash) {
    state.flashes.push(flash)
  },
  [types.addPaginationFlash] (state, flash) {
    state.paginationFlashes.push(flash)
  },
  [types.clearFlash] (state) {
    state.flashes = []
  },
  [types.clearPaginationFlash] (state) {
    state.paginationFlashes = []
  },
  [types.setKeepFlash] (state, bool) {
    state.keepFlash = bool
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shareds/flash/vuex/mutations.js